module.exports = __webpack_public_path__ + "img/jbuilder_512x512.febe776c.png";